<template>
  <div class="empty-tips">
    暂未上线，敬请期待~</div>
</template>
<script>
export default {}
</script>
